import Video from "./Video";

const dataVideos = [
  { videoId: "nNrQLvUGMEM", title: "Jury de la 13ème édition des CJD Business Awards 2022" },
  { videoId: "VGZok84JoX4", title: "Maroua Ben Ali - CEO Herbéos Lauréate du CJD Business Awards 2022" },
  { videoId: "S5Wxx5gH5zE", title: "Fatma Ben Soltane, CEO FIERCE Prix du Leadership" },
  { videoId: "lM20MFL8--4", title: "Selima Zaouali CEO Aseptika Prix de l'Audace" },
  { videoId: "anYOB7ZEqPQ", title: "Anis SAHBANI - Enova Robotics" },
  { videoId: "7UGpLyL3jYQ", title: "Ali KOUKI - Meditec" },
  {
    videoId: "9WAX8Pz4tgE",
    title: "Amine Chouaieb - CJD Business Awards 2015",
  },
  {
    videoId: "22JAZTh3BK4",
    title: "Akram Ben Yahia - Finaliste CJD Business Awards 2015",
  },
  {
    videoId: "AWouYVzaTR8",
    title: "Wassel BERRAYANA - Finaliste CJD Business Awards 2015",
  },
  {
    videoId: "W884MNsZmys",
    title: "CJD Business Awards - Audace Entrepreneuriale - Toumi Lajnef",
  },
  {
    videoId: "CeZUwOthTRU",
    title: "CJD Business Awards - Maitrise Technologique - Abdelkarim Rezgui",
  },
  {
    videoId: "8149tw4iomg",
    title: "CJD Business Awards - Responsabilité Sociétale - Iheb Beji",
  },
  {
    videoId: "BYyqvXM51bs",
    title: "Les anciens lauréats du CJD Business Awards",
  },
  { videoId: "cRfrodQlRWw", title: "AWARD NOMINES" },
];

function VideosList() {
  return (
    <>
      {dataVideos.map((video, key) => {
        return <Video videoId={video.videoId} title={video.title} key={key} />;
      })}
    </>
  );
}

export default VideosList;
